<template>
  <CModal
      :show.sync="addPollModal"
      :centered="true"
      title="ساختن نظرسنجی"
      size="md"
  >
    <CForm class="add-poll-modal text-right">
 <div class="d-flex ">
   <CInput v-model="form.title" label="نام نظرسنجی" class="flex-fill text-sm ml-1" />
   <CSelect
       :options="computedAcl"
       :value.sync="form.acl"
       label="قابل مشاهده"
       class=" text-sm flex-fill mr-1"
   />
 </div>
      <div class="d-flex text-sm mt-2">
      <div class="ml-1  flex-fill">
      <div class="mb-1">  از تاریخ</div>
        <date-picker
            v-model="form.startDate"
            format="jYYYY-jMM-jDD"
            auto-submit
            color="#fbad18"

        />
      </div>
      <div class="mr-1 flex-fill">
      <div class="mb-1">  تا تاریخ</div>
        <date-picker
            v-model="form.endDate"
            format="jYYYY-jMM-jDD"
            color="#fbad18"
            auto-submit

        />
      </div>
      </div>

      <CTextarea v-model="form.text" label="توضیحات" class="text-sm mt-3" />

    </CForm>

    <template #footer>
      <CButton
          :disabled="loading"
          @click="onAddPoll"
          color="primary"
          class="px-5"
      >
        ثبت
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  components: { datePicker: VuePersianDatetimePicker },

  props: {
    value: {
      type: Boolean,
    },
  },
  data() {
    return {
      aclList: [],
      form: {
      },
      loading: false,
    };
  },
  computed: {
    addPollModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedAcl() {
      return this.aclList.map((item) => {
        return {
          value: `${item.value}`,
          label: `${item.title}`,
        };
      });
    },
  },
  watch: {
    addPollModal(val) {
      if(val) {
        this.getAcl();
      }
    }
  },
  methods: {
    async getAcl() {
      try {
        this.loading = true;
        const { data } = await axios.get("survey/acl");
        this.aclList = data;
        this.aclList.unshift({ value: "", title: "" });
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async onAddPoll() {
      try {
        this.loading = true;
        const payload = {
          title: this.form.title,
          text: this.form.text,
          startDate: this.form.startDate,
          endDate: this.form.endDate,
          acl: this.form.acl

        };
        await axios.post("/survey", payload).then((response) => {
          if (response.data) {
            this.form = {};
            this.addPollModal = false;
            this.$emit("get-poll");
          }
        })
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .vpd-container {
    .vpd-content {
      border-radius: 8px;
      .vpd-header {
        border-radius: 8px 8px 0 0;
      }
    }
  }
}
</style>
